import React from 'react';
import {
  dashboardAws, heroImage
} from '../../../../../images/index.js'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="hero-section text-white d-flex flex-column ">
      {/* Headline */}
      <div className="hero-upper-section row justify-content-center">
        <div className="hero-content col-12 col-md-8 h-100 d-flex justify-content-center align-items-center">
          <div className='top-hero-section'>

            <h1 className="fw-bold display-4 display-md-3 mb-3 mt-md-5">
              <span className="hero-heading gradient-text">Revenue Driven.</span>
              <br />
              <span className="hero-heading">Data Visualization</span>
            </h1>

            {/* Subtext */}
            <p className="hero-sub-text mb-5 mt-md-4">
              Helping E-commerce brands grow with guaranteed revenue insights.
            </p>

            {/* Buttons */}
            <div className="d-flex gap-3 mb-5 flex-wrap mt-2">
              <button className="btn hero-btn px-4 py-3 mb-5 me-md-3">
                <Link to={"/signin"} className='text-decoration-none'>Unlock Revenue Clarity</Link>
              </button>
              <button className="btn hero-learn-btn px-4 py-3 mb-5 me-md-3">
               <Link to={"/signin"} className='text-decoration-none'>Learn More</Link> 
              </button>
            </div>
          </div>
        </div>
        <div className=" col-12 col-md-4 h-100 d-none d-md-flex justify-content-center align-items-center">
          <img src={heroImage} alt="hero background" className="hero-bg img-fluid mt-md-5" />
        </div>


      </div>


      {/* Bottom Headline */}
      <div className='bottom-hero-section'>
        {/* <h2 className="hero-heading mb-3 animate__animated animate__slideInUp"> */}
        <motion.h2
          className="hero-heading mb-3"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut",delay:0.1 }}
          viewport={{ once: false }}  
        >
        Scale smarter.<br/>Sales like the top 1%       
        </motion.h2>
        {/* </h2> */}

        <motion.p
        className="hero-sub-text mb-0 mt-4"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        viewport={{ once: false }}
      >
          Unlock the revenue growth, operational freedom, and market dominance you've always envisioned.
        </motion.p>
      </div>
    </section>
  );
};
export default HeroSection;